"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const ownershipAreasService = {
  getOwnershipAreas: function (options) {
    return api.get("/OwnershipAreas", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default ownershipAreasService;
